// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GuestWaitingList, LookEntity } from '@seaters/constants';
import { LexicalEditor } from '@seaters/ui';
import { Card } from 'antd';
import dayjs from 'dayjs';

import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import { useTranslation } from 'react-i18next';
import { decodeAmpHtmlEntity } from './utils';
import { CardHeading } from './CardHeading';

dayjs.extend(LocalizedFormat);

type ExperienceCardProps = {
  fanGroupData: LookEntity;
  waitingListData: GuestWaitingList;
};

export function ExperienceCard({
  fanGroupData,
  waitingListData,
}: ExperienceCardProps) {
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(window.location.search);

  const lang = searchParams.get('lang') || 'en';

  if (!(waitingListData.description && waitingListData.description[lang]))
    return null;

  return (
    <Card title={<CardHeading>{t('guest_app_experience')}</CardHeading>}>
      <LexicalEditor
        borderless
        compact
        disabled
        // PROTOTYPE: video embeds render in the experience description only.
        enableVideo
        placeholder=""
        toolbar={false}
        value={decodeAmpHtmlEntity(waitingListData.description[lang])}
      />
    </Card>
  );
}
